import React from "react";
import { DropDownComponent } from "../../dropdown/DropDownComponent";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";

const FacilitiesDetails = ({
  HandleFormChange,
  formValues,
  companydata,
  HandleCompanyChange,
  company,
  countrydata,
  HandleCountryChange,
  country,
  formErrors,
  setCountry,
  setCompany,
  ClearFormValues,
  HandleFormSubmit
}) => {
  return (
    <div className="card header-card">
      <div className="card-body">
        <div className="card mb-2 general-info-card">
          <div className="card-header">
            <h2>Facility Information</h2>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                <div className="mb-3">
                  <label>
                    Company Name <span className="mandatory">*</span>
                  </label>
                  <DropDownComponent
                    placeholder={PlaceHolder.SELECT_COMPANY}
                    pageName="company"
                    dpDownName="company"
                    stateData={companydata}
                    controlName="companydrp"
                    handleChange={HandleCompanyChange}
                    value={company}
                    valueId={formValues?.companyId}
                    setState={setCompany}
                  />
                  {formErrors?.company && (
                    <p className="form-error">{formErrors?.company}</p>
                  )}
                </div>
                <div className="mb-3">
                  <label>
                    Facility Code <span className="mandatory">*</span>
                  </label>
                  <input
                    className="form-control"
                    name="facilityCode"
                    value={formValues?.facilityCode || ""}
                    type="text"
                    placeholder="Enter facility code"
                    onChange={HandleFormChange}
                  />
                  {formErrors?.facilityCode && (
                    <p className="form-error">{formErrors?.facilityCode}</p>
                  )}
                </div>
                <div className="mb-3">
                  <label>
                    Facility Name <span className="mandatory">*</span>
                  </label>
                  <input
                    className="form-control"
                    name="facilityName"
                    value={formValues?.facilityName || ""}
                    type="text"
                    placeholder="Enter facility name"
                    onChange={HandleFormChange}
                  />
                  {formErrors?.facilityName && (
                    <p className="form-error">{formErrors?.facilityName}</p>
                  )}
                </div>
                <div className="mb-3">
                  <label>
                    Country <span className="mandatory">*</span>
                  </label>

                  <DropDownComponent
                    placeholder="Select Country"
                    pageName="country"
                    dpDownName="country"
                    stateData={countrydata}
                    controlName="countrydrp"
                    handleChange={HandleCountryChange}
                    value={country}
                    valueId={formValues?.countryId}
                    setState={setCountry}
                  />

                  {formErrors?.country && (
                    <p className="form-error">{formErrors?.country}</p>
                  )}
                </div>
              </div>
              
              <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                <div className="mb-3">
                  <label>
                    Address <span className="mandatory">*</span>
                  </label>
                  <textarea
                    className="form-control address-text-area"
                    name="address"
                    value={formValues?.address || ""}
                    placeholder="Enter address"
                    onChange={HandleFormChange}
                  />
                  {formErrors?.address && (
                    <p className="form-error">{formErrors?.address}</p>
                  )}
                </div>
                <div className="mb-3">
                  <div className="form-group mb-0">
                    <input
                      type="checkbox"
                      id="isDefault"
                      name="isDefault"
                      checked={!!formValues?.isDefault}
                      onChange={HandleFormChange}
                    />
                    <label htmlFor="isDefault" className="mb-0">
                     Is Default
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3 px-2">
                <div className="save-btns d-flex justify-content-end">
                  <button className="btn cancel-btn" onClick={ClearFormValues}>
                    Cancel
                  </button>
                  <button className="btn save-btn" onClick={HandleFormSubmit}>
                    {!formValues?.id ? "Save" : "Update"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacilitiesDetails;
